import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {AnalyticsVisualization} from 'insights/analytics-visualizations/__generated/AnalyticsVisualization';
import {performLinearRegressionAnalysis} from 'ui-library/charting/statistics/regression/LinearRegression';
import {performLogisticRegressionAnalysis} from 'ui-library/charting/statistics/regression/LogisticRegression';
import {
  assertRegressionDatasetIsNumerical,
  RegressionAnalysis,
  RegressionDataset,
  RegressionConfig,
  RegressionType,
} from 'ui-library/charting/statistics/regression/RegressionTypes';
import {assertNever} from 'util/Types';

type OutlierConfig = NonNullable<
  ExtractByTypename<
    AnalyticsVisualization['parameters'],
    'AnalyticsVisualizationScatterPlotParametersNode'
  >['outlierConfig']
>;

export default function performRegressionAnalysis(
  dataset: RegressionDataset,
  regressionConfig: RegressionConfig,
  setRegressionAnalysis: (regressionAnalysis: RegressionAnalysis) => void,
  outlierConfig: OutlierConfig | null = null
): void {
  const {regressionType} = regressionConfig;
  switch (regressionType) {
    case RegressionType.LINEAR:
      setRegressionAnalysis(performLinearRegressionAnalysis(dataset));

      break;
    case RegressionType.QUADRATIC:
      throw new Error(`Unsupported non-Analysis tool regression type: ${RegressionType.QUADRATIC}`);

    case RegressionType.LOGISTIC:
      assertRegressionDatasetIsNumerical(dataset);
      performLogisticRegressionAnalysis(dataset, regressionConfig, setRegressionAnalysis, outlierConfig);
      break;
    default:
      throw new Error(`Invalid regression type ${assertNever(regressionType)}`);
  }
}
